const Barba = require('barba.js');

var HomepageScrolling = function(){
    Utils.debug('HomepageScrolling');
}


/**
 * Fonction qui permet d'ajuster le grossissement des background dans les slices
 * Genre de background cover du pauvre
 * attention les images doivent avoir le même ratio a savoir 1920*1200
 * @returns {number}
 */
var ajustBackGroundScale = function(){
    let scaleBg = 100;
    let offsetX = 0;
    let w = Verge.viewportW(),
        h = Verge.viewportH(),
        iw = 1920,
        ih = 1200,
        r = Math.min(w / iw, h / ih),
        nw = Math.round(iw * r),
        nh = Math.round(ih * r),
        ar = 1;

    if (nw < w){
        ar = w / nw;
        //scaleBg = Math.ceil(ar*100);
        scaleBg = Math.round(ar*100*1000) / 1000;
        $('.homeEffect-img span').css({
            backgroundSize: 'auto '+scaleBg+'%'
        })
    }


    //console.debug('nh', nh, 'h', h);


    if (nh < h) {
        let newW = iw * h / ih;
        offsetX = (h / nh * 100)/8;
        $('.homeEffect-slice').each(function(elt){
            let $img = $(this).find('span');
            let posX = (w/8*elt) - ((w-newW)/2);
            $img.css('backgroundPosition', -posX+'px center');
        });

    }






}



var Homepage = Barba.BaseView.extend({
    namespace: 'home',

    onEnter2: function() {},

    onEnter: function() {
        //console.debug('HOME : The new Container is ready and attached to the DOM.');

        let $sectionBg = $('.section-bg');
        let sectionLenght = $('.section').length;
        let activeSection = 1;
        let nextSection = 1;
        let inHome = 1;
        let $homeBaseline = $('.agencePres');
        let $homeLetters = $('.homeEffect-letter');
        let $homeLettersMini = $('.homeEffect-letterMini');
        let $homeImg = $('.homeEffect-img');
        let vpHeight = Verge.viewportH();
        let currentId = 1;
        let nbSlice = 1;
        let canRemoveSlices = 0;
        let TL_home = 0;
        let isCurrentlyClose = 0;

/*
        let $homeEffect = $('.homeEffect');
        let homeEffectW = $homeEffect.innerWidth();
        let colwidth = Math.round(homeEffectW / 8);
        $homeEffect.find('> .homeEffect-slice').css('width', colwidth);
        let gap = homeEffectW - (colwidth*8);
        if(gap > 0){
            $homeEffect.find('> .homeEffect-slice:last-child').css('width', colwidth + gap);
        } else {
            $homeEffect.find('> .homeEffect-slice:last-child').css('width', colwidth - gap);
        }
*/




        var closeHome = function(){
            Utils.debug('close home');
            isCurrentlyClose = true;
            inHome = 0;

            TweenMax.set('.homeEffect-letterBig', {opacity: 0});
            TweenMax.set('.homeEffect-slice', {alpha: 1});

            //if(TL_home) TL_home.pause();
            TL_home = new TimelineMax({onComplete: function(){
                TweenMax.set($homeLetters, {display: 'none'});
                Utils.debug('closeHome Complete');
                    isCurrentlyClose = false;
            }});
            TL_home.to($homeBaseline, 0.3, {opacity: 0});
            TL_home.to('.brandMobile, .scrollAnim', 0.3, {opacity: 0});

            $homeLettersMini.each(function(elt){
                if(elt % 2 == 0){
                    TweenMax.to(this, 0.5, {yPercent: 100, ease: Ease.easeInOut});
                } else {
                    TweenMax.to(this, 0.5, {yPercent: -100, ease: Ease.easeInOut});
                }
            });



            //$('.bottomImg').remove();
            $('.section-bg').each(function(){
                let newBg = $(this).data('visuel');
                $homeImg.each(function(){
                    $(this).append('<span class="bottomImg" style="background-image: url('+newBg+')"></span>')
                });
            });

            ajustBackGroundScale();

        }

        var openHome = function(bulb){
            Utils.debug('openHome home');
            inHome = 1;


            TweenMax.set($homeLetters, {display: 'block'});
            TweenMax.set('.homeEffect-letterBig', {opacity: 1});

            //$homeImg.find('.topImg:not(:last)').remove();
            //nbSlice = 1;
            //if(TL_home) TL_home.pause();

            TL_home = new TimelineMax();
            TL_home.to($homeBaseline, 0.3, {opacity: 1});
            TL_home.to('.brandMobile, .scrollAnim', 0.3, {opacity: 1});
            $homeLettersMini.each(function(elt){
                TweenMax.to(this, 0.5, {yPercent: 0, ease: Ease.easeInOut});
            });

            if(!bulb.lowVersion){
                TweenMax.staggerTo(
                    $homeImg,
                    0.5,
                    { y: 0, ease: Ease.easeInOut},
                    0.05,
                    function(){
                        Utils.debug('openHome Complete');
                        $('.bottomImg').remove();
                        //
                    }
                );
            } else {
                TweenMax.set($homeImg, {y: 0});
            }


        }

        $('body').on('bulb:resizeActions', function(event){
           ajustBackGroundScale();
        });


        $('body').on('scrolling', function(event){

            if(event.newY < 2 && !inHome){
                openHome(event.bulb);
            }

            if(event.newY > 2 && inHome){
                closeHome();
            }

            let vpHeight = Verge.viewportH();
            if(!inHome && event.device.isDesktop && !event.device.isIpad ){
                // calcul du pourcentage d'apparition de la section suivante
                let $item = $('.section-bg__'+activeSection);
                let itemH = $item.outerHeight();
                let itemViewportOffset = $item.get(0).getBoundingClientRect();

                let itemHVisible = (vpHeight - itemViewportOffset.top);
                if(itemHVisible < 0) itemHVisible = 0;
                if(itemHVisible > itemH) itemHVisible = itemH;
                let itemVisiblePercent = Math.round(itemHVisible * 100 / itemH);
                let nbSlices = $('.homeEffect-slice:first-child > .homeEffect-img > span').length;
                $homeImg.each(function(elt){

                    let pas = vpHeight * itemVisiblePercent * (elt+1) / 100;
                    if(pas > vpHeight) pas = vpHeight;
                    let y =  (vpHeight * (nbSlices - (7-activeSection) )) + pas;
                    TweenMax.to(this, 0.2, {y: -y})
                });
            }


            if(event.device.isIpad){

                let ipadHeight = $(window).height() + 60;

                $('.homeEffect').css('height', ipadHeight);
                $('.homeEffect-img span').css('height', ipadHeight);
                if(!inHome){
                    TweenMax.set($homeImg, {y: -ipadHeight * activeSection });
                }
            }



        });


        $sectionBg.on('reveal', function(event){

            activeSection = $(this).data('section');
            let img = $(this).data('visuel');


            if(!event.lowVersion && (event.device.isTablet || event.device.isIpad)){

                let vh = Verge.viewportH();
                TweenMax.staggerTo(
                    $homeImg,
                    0.5,
                    { y: -vh * activeSection, ease: Ease.easeInOut},
                    0.05
                );
            }

            // pas d'animation pour les lowversion
            if(event.lowVersion){
                let vh = Verge.viewportH();
                TweenMax.set($homeImg, {y: -vh * activeSection });
            }

            /*
             let $homeBackground = $('.homeBackground');
             let $img = $('<div class="homeBackground-visuel"></div>');
             $img.css({'opacity': 0, 'backgroundImage': 'url(' + $(this).data('visuel') + ')'});
             $homeBackground.append($img);
             TweenMax.to($img, 0.2, {alpha: 1, onComplete: function(){$homeBackground.find('.homeBackground-visuel:first-child').remove();}});
             */


            // gestion des base line de la home a fixe / defix en top
            // si on est entrain de remonter les elements
            // on va debloquer la base line précédente
						/*
            if(event.way == 'UP'){
                $(this).parent('.section').prev('.section').find('.section-baseline ').removeClass('parallaxable__fixeToTop');
                $(this).parent('.section').next('.section').find('.section-baseline ').addClass('parallaxable__fixeToTop');
            }
            */
        })


				/*
        $sectionBg.on('unreveal', function(event){
            if(event.way == 'DOWN'){
                $(this).parent('.section').next('.section').find('.section-baseline ').removeClass('parallaxable__fixeToTop');
                $(this).parent('.section').prev('.section').find('.section-baseline ').addClass('parallaxable__fixeToTop');
            }
        })
				*/


        // trouver le grossissement des images pour remplir tout l'écran
        ajustBackGroundScale();



        $('.homeEffect-slice__active .homeEffect-letter').each(function(){
           let $elt = $(this);


           $elt.on('mouseover', function(){


               let img  = $(this).data('img');
               let id  = $(this).data('section');
               let vh = Verge.viewportH();
               canRemoveSlices = false;

               if(currentId == id) return false;
               currentId = id;

               //$homeImg.find('span:not(:last)').remove();

               $homeImg.each(function(){
                    $(this).append('<span class="topImg" style="background-image: url('+img+')"></span>')
               });

               ajustBackGroundScale();

               nbSlice = nbSlice + 1;
               let $otherSlices = $(this).parent('.homeEffect-slice').siblings('.homeEffect-slice');

               TweenMax.set($otherSlices, {alpha: 0.3});
               TweenMax.to($(this).find('> div'), 0.4, {yPercent: -100});

               TweenMax.staggerTo(
                   $homeImg,
                   0.5,
                   { y: -vh * (nbSlice-1), ease: Ease.easeInOut},
                   0.05,
                   function(){
                       canRemoveSlices = true;
                       setTimeout(function(){
                           Utils.debug('Complete > canRemoveSlices > '+canRemoveSlices);
                           if(canRemoveSlices){
                               TweenMax.to('.homeEffect-slice', 0.3, {alpha: 1});
                               TweenMax.set($homeImg, {y: 0});
                               if(!isCurrentlyClose) {
                                   $homeImg.find('span:not(:last)').remove();
                               }
                               nbSlice = 1;
                           }

                       }, 200);

                   }
               );



           });

            $elt.on('mouseleave', function(){
                TweenMax.to($(this).find('> div'), 0.4, {yPercent: 0});
                TweenMax.set('.homeEffect-slice', {alpha: 1});
            });

        });




    },


    onEnterCompleted: function() {
        //console.debug('HOME : The Transition has just finished.');
    },
    onLeave: function() {
        //console.debug('HOME : A new Transition toward a new page has just started.');
    },
    onLeaveCompleted: function() {
        //console.debug('HOME : The Container has just been removed from the DOM.');
        $('body').off('scrolling');
    }
});


module.exports = Homepage;
